import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import accountReducer from './accountSlice';
import uiReducer from './uiSlice';
import monthReducer from './monthSlice';
import organizationReducer from './allOrgSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    account: accountReducer,
    ui: uiReducer,
    month: monthReducer,
    organization: organizationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export const userState = (state: RootState) => state.user;
export const accountState = (state: RootState) => state.account;
export const uiState = (state: RootState) => state.ui;
export const organizationState = (state: RootState) => state.organization;
export type AppDispatch = typeof store.dispatch;

export default store;
